<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('forecast.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="title-box">
                <div class="title-left">{{$t('forecast.title0')}}</div>
                <div class="title-right">（{{$t('forecast.prot')}}：{{forecastLatest.date ? forecastLatest.date.slice(5, 10).replace(/-/g, '/') : '--'}}）</div>
            </div>
            <div class="info-box">
                <div class="bar bar1"></div>
                <div class="bar bar2"></div>
                <div class="bar bar3"></div>
                <div class="bar bar4"></div>
                <div class="key key1">5K</div>
                <div class="key key2">10K</div>
                <div class="key key3">{{$t('forecast.level2')}}</div>
                <div class="key key4">{{$t('forecast.level3')}}</div>
                <div class="value value1">{{forecastLatest ? formatSeconds2(forecastLatest.forecast5Latest) : '--'}}</div>
                <div class="value value2">{{forecastLatest ? formatSeconds2(forecastLatest.forecast10Latest) : '--'}}</div>
                <div class="value value3">{{forecastLatest ? formatSeconds2(forecastLatest.forecastHalfLatest) : '--'}}</div>
                <div class="value value4">{{forecastLatest ? formatSeconds2(forecastLatest.forecastMarathonLatest) : '--'}}</div>
                <div class="line line1"></div>
                <div class="line line2"></div>
                <div class="line line3"></div>
            </div>
            <div class="title-box">
                <div class="title-left">{{$t('forecast.title1')}}<img class="best-icon"
                                                                      :src="require(`@/assets/theme/${theme}/status/16forecast/01best.svg`)">
                </div>
                <div class="title-right">（{{$t('forecast.prot')}}：{{forecastBest.date ? forecastBest.date.slice(5, 10).replace(/-/g, '/') : '--'}}）</div>
            </div>
            <div class="info-box">
                <div class="bar bar1"></div>
                <div class="bar bar2"></div>
                <div class="bar bar3"></div>
                <div class="bar bar4"></div>
                <div class="key key1">5K</div>
                <div class="key key2">10K</div>
                <div class="key key3">{{$t('forecast.level2')}}</div>
                <div class="key key4">{{$t('forecast.level3')}}</div>
                <div class="value value1">{{forecastBest ? formatSeconds2(forecastBest.forecast5Best) : '--'}}</div>
                <div class="value value2">{{forecastBest ? formatSeconds2(forecastBest.forecast10Best) : '--'}}</div>
                <div class="value value3">{{forecastBest ? formatSeconds2(forecastBest.forecastHalfBest) : '--'}}</div>
                <div class="value value4">{{forecastBest ? formatSeconds2(forecastBest.forecastMarathonBest) : '--'}}</div>
                <div class="line line1"></div>
                <div class="line line2"></div>
                <div class="line line3"></div>
            </div>
            <div class="desc-box">
                <div class="desc-title">{{$t('forecast.descTitle')}}</div>
                <div class="desc-info desc-last">
                    {{$t('forecast.desc')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {formatSeconds2} from '@/utils/dateUtils'
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'forecast',
        data() {
            return {
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                forecastBest: {
                    "date": "",
                    "forecast5Best": 0,
                    "forecast10Best": 0,
                    "forecastHalfBest": 0,
                    "forecastMarathonBest": 0
                },
                forecastLatest: {
                    "date": "",
                    "forecast5Latest": 0,
                    "forecast10Latest": 0,
                    "forecastHalfLatest": 0,
                    "forecastMarathonLatest": 0
                }
            }
        },
        mounted() {
            document.documentElement.setAttribute("theme", this.theme)
            if (getQueryVariable("token")) {
                localStorage.setItem("token", getQueryVariable("token"));
            }
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            getData() {
                this.$api.status.queryForecastNew().then(res => {
                    if (res.result == 1) {
                        this.forecastLatest = res.info.forecastLatest
                        this.forecastBest = res.info.forecastBest
                    }
                })
            },
            formatSeconds2(num) {
                return formatSeconds2(num)
            }
        }
    }
</script>

<style scoped>

    .title-box {
        margin-top: 10px;
        height: 17px;
    }

    .title-left {
        color: var(--text-color-1);
        font-size: 15px;
        margin-left: 15px;
        float: left;
    }

    .title-right {
        color: var(--text-color-2);
        font-size: 13px;
        margin-right: 16px;
        float: right;
    }

    .info-box {
        width: 345px;
        height: 165px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 10px auto 15px;
        position: relative;
    }

    .bar {
        width: 4px;
        height: 11px;
        border-radius: 3px 3px 3px 3px;
        position: absolute;
        left: 28px;
    }

    .bar1 {
        top: 18px;
        background-color: var(--chart-color-1);
    }

    .bar2 {
        top: 57px;
        background-color: var(--chart-color-8);
    }

    .bar3 {
        top: 96px;
        background-color: var(--chart-color-5);
    }

    .bar4 {
        top: 136px;
        background-color: var(--chart-color-3);
    }

    .key {
        font-size: 13px;
        position: absolute;
        left: 41px;
        color: var(--text-color-2);
        line-height: 15px;
    }

    .key1 {
        top: 16px;
    }

    .key2 {
        top: 55px;
    }

    .key3 {
        top: 94px;
    }

    .key4 {
        top: 134px;
    }

    .value {
        position: absolute;
        right: 24px;
        font-size: 13px;
        color: var(--text-color-1);
    }

    .value1 {
        top: 16px;
    }

    .value2 {
        top: 55px;
    }

    .value3 {
        top: 94px;
    }

    .value4 {
        top: 133px;
    }

    .line {
        width: 295px;
        height: 0px;
        border-bottom: 1px solid var(--bg-color-1);
        position: absolute;
        left: 26px;
    }

    .line1 {
        top: 44px;
    }

    .line2 {
        top: 83px;
    }

    .line3 {
        top: 122px;
    }

    .best-icon {
        width: 16px;
        margin-left: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/16forecast.vue